import { ReactElement } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import type { PlanImageCard } from 'src/domain/planImageCards/types'

interface ImageCardRowProps {
  planImageCard: PlanImageCard
  selected: boolean
  isPlaceholder: boolean
  onSelect: (id: string) => void
}

const ImageCardRow = ({
  planImageCard,
  selected,
  isPlaceholder,
  onSelect,
}: ImageCardRowProps): ReactElement => {
  const theme = useTheme()

  return (
    <Box
      data-cy={`plan-image-card-row-${planImageCard.id}`}
      onClick={() => onSelect(planImageCard.id)}
      sx={{
        px: 1,
        py: 0.75,
        cursor: 'pointer',
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: selected ? theme.palette.action.selected : 'transparent',
        '&:hover': {
          backgroundColor: selected ? theme.palette.action.selected : theme.palette.action.hover,
        },
      }}
    >
      <Typography variant="body2" sx={{ fontSize: 13 }}>
        {planImageCard.name}
      </Typography>
      {isPlaceholder && (
        <Typography variant="caption" color="warning.main">
          Kein Bild
        </Typography>
      )}
    </Box>
  )
}

export default ImageCardRow
